import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { ScheduleService } from './schedule.service';

export const Ng1ScheduleModule = angular
  .module('control-room.shared.services.schedule', [])
  .factory('crScheduleService', downgradeInjectable(ScheduleService));
